"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonCard = void 0;
const React = require("react");
const filters_1 = require("../../../utils/filters/filters");
const Spinner_1 = require("../../Spinner");
const cards_type_1 = require("./cards.type");
const BronsonCard = (props) => {
    const { data, columns, showEdit, showDelete, showDownload, cardState, loadingDownload, onClickEdit, onClickDelete, onClickDownload, floatIcon, hideHeader, } = props;
    const DownloadComponent = (center) => {
        if (loadingDownload) {
            return (React.createElement("div", { className: 'u-float-right u-float-none@s u-ml-small', style: { display: center ? 'inline-block' : 'block' } },
                React.createElement(Spinner_1.BronsonSpinner, { config: {
                        showSpinner: true,
                    } })));
        }
        else {
            return (React.createElement("a", { "data-component": `download-dualview-card${center ? '-centered' : ''}`, onClick: onClickDownload },
                React.createElement("i", { className: 'u-text-brand u-ml-xsmall u-ml-small@xs c-icon c-icon--medium c-icon--[control-download]' })));
        }
    };
    const setHeader = (currentData) => {
        const showSubtitle = currentData.subtitleLabel && currentData.subtitleValue;
        const styleHeader = showSubtitle ? 'u-mv-small' : 'u-mv-none';
        const subtitle = showSubtitle ? (React.createElement(React.Fragment, null,
            React.createElement("b", { className: 'u-text-brand' },
                currentData.subtitleLabel,
                ": "),
            React.createElement("span", { className: 'u-text-base' }, currentData.subtitleValue))) : (React.createElement(React.Fragment, null));
        return (React.createElement("div", { className: 'o-layout__item u-mt-small u-pv-small u-1/1  u-1/1@s' },
            React.createElement("div", { id: 'card-header', className: 'o-layout__item u-pl-none  u-3/4  u-1/1@s' },
                React.createElement("h3", { className: 'u-text-base u-text-uppercase u-m-none' }, currentData.title),
                subtitle),
            React.createElement("div", { className: 'o-layout__item  u-1/4  u-1/1@s u-hide@s' },
                React.createElement("div", { className: `u-text-right ${styleHeader}` },
                    showEdit && (React.createElement("a", { "data-component": 'edit-dualview-card', id: currentData.id, onClick: onClickEdit },
                        React.createElement("i", { className: 'u-text-brand c-icon c-icon--medium c-icon--[control-pen]' }))),
                    showDelete && (React.createElement("a", { "data-component": 'delete-dualview-card', id: currentData.id, onClick: onClickDelete },
                        React.createElement("i", { className: 'u-text-brand u-ml-xsmall  c-icon c-icon--medium c-icon--[semantic-delete]' }))),
                    showDownload && DownloadComponent()))));
    };
    const setCard = (currentData) => {
        const dataBody = !currentData.childElement && currentData.information
            ? currentData.information.map((elem, index) => (React.createElement("div", { className: `o-layout__item u-p-none u-1/${columns}  u-1/1@s`, key: index },
                React.createElement("b", { className: 'u-text-brand' }, elem.label),
                React.createElement("p", { className: 'u-text-base' }, elem.value))))
            : currentData.childElement;
        const showSubtitle = currentData.subtitleLabel && currentData.subtitleValue;
        const styleHeader = showSubtitle ? 'u-mv-small' : 'u-mv-none';
        return (React.createElement(React.Fragment, null,
            !hideHeader && setHeader(currentData),
            React.createElement("div", { "data-component": 'dh-card-items', className: 'o-layout__item' },
                dataBody,
                React.createElement("div", { className: 'o-layout' },
                    React.createElement("div", { className: 'o-layout__item' },
                        React.createElement("div", { className: `u-text-center u-hide@s-up ${styleHeader}` },
                            showEdit && (React.createElement("a", { id: currentData.id, onClick: onClickEdit },
                                React.createElement("i", { className: 'u-text-brand c-icon c-icon--medium c-icon--[control-pen]' }))),
                            showDelete && (React.createElement("a", { id: currentData.id, onClick: onClickDelete },
                                React.createElement("i", { className: 'u-text-brand u-ml-xsmall u-ml-small@xs' +
                                        ' c-icon c-icon--medium c-icon--[semantic-delete]' }))),
                            showDownload && DownloadComponent(true)))))));
    };
    const noInfo = (React.createElement("div", { id: 'no-info-card', className: 'o-layout__item u-text-center' },
        React.createElement("h4", null, "No se encontr\u00F3 informaci\u00F3n para mostrar")));
    const renderCard = () => {
        if (cardState === cards_type_1.BronsonCardState.isLoading) {
            return (React.createElement("div", { "data-component": 'dh-card-spinner', className: 'o-layout__item u-mb-small u-pt-xsmall' },
                React.createElement(Spinner_1.BronsonSpinner, { config: {
                        spinnerWrapperClassModifier: 'c-spinner--center',
                        showSpinner: true,
                    } })));
        }
        let currentData = Object.assign({}, data);
        let showInfo = false;
        if (data.information && data.information.length) {
            showInfo = true;
            const information = data.information.map((elem) => {
                if (elem.format) {
                    const newValue = (0, filters_1.applyFilter)(elem.format, elem.value, elem.args ? elem.args : {});
                    return Object.assign(Object.assign({}, elem), { value: newValue });
                }
                return elem;
            });
            currentData = Object.assign(Object.assign({}, data), { information });
        }
        else if (data.childElement) {
            showInfo = true;
        }
        return (React.createElement("div", { className: 'o-layout  o-layout--divider' }, showInfo ? setCard(currentData) : noInfo));
    };
    return (React.createElement("div", null,
        !floatIcon ? (React.createElement("hr", { style: { height: '3px' } })) : (React.createElement("i", { "data-component": 'card-icon', className: `c-icon c-icon--[${floatIcon}] c-icon--large u-round u-bg-brand u-ml u-p-xsmall u-text-white`, "aria-hidden": 'true', role: 'img' })),
        React.createElement("div", { className: 'o-fieldset u-bg-pale' },
            React.createElement("div", { className: 'o-fieldset__row' },
                React.createElement("div", { className: 'o-layout' },
                    React.createElement("div", { className: 'o-layout__item  u-1/1 u-1/1@s' },
                        React.createElement("div", { className: 'u-mh' },
                            React.createElement("div", { className: 'u-block u-mb-small' }, renderCard()))))))));
};
exports.BronsonCard = BronsonCard;
